export class SimplyWhiteDashboardBuildData{
	module = {
        name: "Dashboard",
        new_name: "dashboard",
        has_dot_menu: true,
        icon:'',
        permission:'dashboard'
    }
}